/**
 * Spalte der Bestellliste -> Stelle im Bestell-Drawer, an der der Wert steht.
 *
 * Wer im Grid auf eine Zelle klickt, die er dort nicht aendern kann (`NICHT_BEARBEITBAR`, eine
 * Sperre aus `orderListEditorRegel` oder fehlendes `edit_orders`), bekommt statt einer Meldung den
 * Drawer - an der Stelle, an der das Feld wirklich steht. Die Zuordnung ist hier an EINER Stelle
 * gesammelt, nicht im JSX verstreut.
 *
 * GEMESSEN am Drawer-Baum (Stand 2026-10-04), nicht vermutet:
 * - `name`: die Bestellnummer sitzt im Kopf (`DrawerKopf`), ueber allen Reitern - kein Abschnitt.
 * - `due`: das Faelligkeitsdatum steht als `.drawer-order-due` ueber den Abschnitten von `main`
 *   (`BestellungTab`), NICHT in `pay-plan` (dort stehen die Ratentermine, ein anderes Datum).
 * - `value`: die Summe steht im Abschnitt `main-items` (`Positionen`), nicht in `main-data`.
 * - `etdPi`: `Termine` (ETD (PI)) im Abschnitt `main-data`; `etd`/`eta`: `Transport` in `ship-transport`.
 * - `invoiceNo`, `supplier`: `Stammdaten` im Abschnitt `main-data`.
 * - `dsvShipmentNo`: die verknuepfte Sendung steht im ersten Abschnitt des Reiters Spedition, `ship-sendung`.
 * - `zoll`: „Zollinstruktionen anstossen" bekommt seinen Knopf im Reiter Spedition (`ship`); einen eigenen
 *   Abschnitt (`data-sec`) gibt es dort nicht, deshalb nur der Reiter.
 * - `payment`: „Zahlung anstossen" ist der Abschnitt `pay-action` (nicht `pay-plan`).
 * - `booked`: „Ware eingebucht" ist der Reiter Anlieferung (`Anlieferungsliste`) - er hat keine Abschnitte.
 * - `custom_*` (eigene Listenfelder): im Drawer gibt es dafuer keine Stelle - nur der Reiter `main`.
 */
import type { DrawerTabId } from "../components/Drawer/drawerRechte.ts";

/** Das Ziel eines Drawer-Sprungs: Reiter und - optional - der `data-sec`-Schluessel des Abschnitts. */
export interface DrawerZiel {
  tab: DrawerTabId;
  abschnitt?: string;
}

const ZIELE: ReadonlyMap<string, DrawerZiel> = new Map<string, DrawerZiel>([
  ["name", { tab: "main" }],
  ["supplier", { tab: "main", abschnitt: "main-data" }],
  ["invoiceNo", { tab: "main", abschnitt: "main-data" }],
  ["status", { tab: "main", abschnitt: "main-status" }],
  ["due", { tab: "main" }],
  ["value", { tab: "main", abschnitt: "main-items" }],
  ["etdPi", { tab: "main", abschnitt: "main-data" }],
  ["etd", { tab: "ship", abschnitt: "ship-transport" }],
  ["eta", { tab: "ship", abschnitt: "ship-transport" }],
  ["dsvShipmentNo", { tab: "ship", abschnitt: "ship-sendung" }],
  ["zoll", { tab: "ship" }],
  ["payment", { tab: "pay", abschnitt: "pay-action" }],
  ["booked", { tab: "arrival" }],
]);

/** Der Rueckfall fuer jede unbekannte Spalte, auch `custom_*`: der Reiter „Bestellung". */
const RUECKFALL: DrawerZiel = { tab: "main" };

export function zellZiel(spaltenschluessel: string): DrawerZiel {
  const ziel = ZIELE.get(spaltenschluessel) ?? RUECKFALL;
  return { ...ziel };
}
